import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Entry } from "../../models/entry.model";

@Injectable()
export class EntryProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  create(challengeID: number, data: any): Observable<Entry> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/entries/${challengeID}`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/entry/entry.ts